"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const modal_1 = require("../../modal");
const mappingComp_1 = require("./mappingComp");
/**Intercambia 2 elementos de un arreglo, si los indices dados estan afuera del arreglo, devuelve el arreglo sin modificar */
function swapItems(array, a, b) {
    const inside = (x) => x >= 0 && x < array.length;
    if (!inside(a) || !inside(b))
        return array;
    return array.map((x, i, arr) => i == a ? arr[b] :
        i == b ? arr[a] :
            arr[i]);
}
/**Mueve un elemento del arreglo, si el elemento no se puede mover en esta dirección debido a que esta en la esquina del arreglo devuelve el arreglo sin modificar */
function moveItem(array, index, dir) {
    return swapItems(array, index, index + (dir == "up" ? -1 : +1));
}
class MappingComponent extends React.PureComponent {
    constructor() {
        super(...arguments);
        this.handleOnMappingChange = (mapping) => {
            const oldValue = this.props.state;
            const newwValue = Object.assign({}, oldValue, { mapping });
            this.props.onStateChange(newwValue);
        };
    }
    render() {
        const props = this.props;
        return (this.props.show ?
            React.createElement(modal_1.Modal, { buttons: [], onClose: this.props.onClose, title: "Seleccionar columnas" },
                React.createElement(mappingComp_1.ColumnMappingComponent, { columnas: props.columnas, onChange: this.handleOnMappingChange, value: props.state.mapping })) : null);
    }
}
exports.MappingComponent = MappingComponent;



//////////////////
// WEBPACK FOOTER
// ./~/kea-react/dist/grid2Base/components/mappings.js
// module id = 2224
// module chunks = 0